import { Component, OnInit, OnDestroy, HostListener, Renderer2 } from '@angular/core';
import { RoleService } from 'src/app/services/role.service';
import { Router } from '@angular/router';
import { NewsService } from 'src/app/services/news.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PrintarticleService } from 'src/app/services/printarticle.service';
import { DigitalarticleService } from 'src/app/services/digitalarticle.service';
import { DigitalmediaService } from 'src/app/services/digitalmedia.service';

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})

export class MediaComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  NewsArticals: any[] | undefined;
  printArticles: any[] | undefined;
  displayBasic: boolean | undefined;
  public showHighlightImg = "";
  newsSlider = {
    effect: 'slide',
    slidesPerView: 3,
    spaceBetween: 20,  // Adjust spacing as needed
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1.3,
        spaceBetween: 0,
      },
      370: {
        slidesPerView: 1.3,
        spaceBetween: 0,
      },
      767: {
        slidesPerView: 1.3,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      993: {
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: false,
      },
    },
  };
  responsiveOptions: any[] = [
    {
      breakpoint: '1500px',
      numVisible: 5
    },
    {
      breakpoint: '1024px',
      numVisible: 3
    },
    {
      breakpoint: '768px',
      numVisible: 2
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  newsList: any[] = [];
  PrintArticals: any[] = [];
  DigitalArticles: any[] = [];
  DigitalMedia: any[] = [];

  constructor(
    private renderer: Renderer2,
    private roleService: RoleService,
    private router: Router,
    private newsService: NewsService,
    private printarticleService: PrintarticleService,
    private digitalarticleService: DigitalarticleService,
    private digitalmediaService: DigitalmediaService
  ) { }

  ngOnInit(): void {
    this.getNewsList();
    this.getPrintarticleList();
    this.getDigitalarticleList();
    this.getDigitalmediaList();

    this.renderer.addClass(document.body, "mediaPage");
    this.roleService.setCurrentActiveRoute2(this.router.url);

    this.printArticles = [
      {
        src: 'assets/img/news/Print/image/1.jpg'
      },
    ]
    this.renderer.addClass(document.body, "mediaPage");
    this.roleService.setCurrentActiveRoute2(this.router.url);
  }

  getNewsList() {
    const query = '?filterByDisable=false&pageSize=10&pageNumber=1';

    this.newsService.getNewsList(query)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          this.NewsArticals = res.data.items.map((item: any) => ({
            heading: item.title,
            link: item.url,
            src: item.newsImage,
            channelName: item.channelName,
            createdAt: item.created_at
          }));
        },
        (err) => {
          console.error(err);
        }
      );
  }


  getPrintarticleList() {
    const query = '?filterByDisable=false&pageSize=10&pageNumber=1';

    this.printarticleService.getPrintarticleList(query)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          this.printArticles = res.data.items.map((item: any) => ({
            name: item.printarticleName,
            src: item.printarticleImage
          }));
        },
        (err) => {
          console.error(err);
        }
      );
  }

  getDigitalarticleList() {
    const query = '?filterByDisable=false&pageSize=10&pageNumber=1';

    this.digitalarticleService.getDigitalarticleList(query)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          this.DigitalArticles = res.data.items.map((item: any) => ({
            name: item.digitalarticleName,
            channelName: item.channelName,
            src: item.digitalarticleImage,
            link: item.url,
            logo: item.logoImage
          }));
        },
        (err) => {
          console.error(err);
        }
      );
  }

  getDigitalmediaList() {
    const query = '?filterByStatus=true&filterByDisable=false&pageSize=10&pageNumber=1';

    this.digitalmediaService.getDigitalmediaList(query)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          this.DigitalMedia = res.data.items.map((item: any) => ({
            name: item.digitalmediaName,
            channelName: item.channelName,
            src: item.digitalmediaImage,
            logo: item.logoImage,
            link: item.url
          }));

        },
        (err) => {
          console.error(err);
        }
      );
  }

  public openHightlightImage(highlight) {
    this.displayBasic = true
    this.showHighlightImg = highlight.src;
  }

  @HostListener('window:keyup.esc', ['$event']) w(e: KeyboardEvent) {
    this.displayBasic = false;
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, "mediaPage");
  }

}